import { debounce } from 'throttle-debounce'

export default (selectedYear) => ({
    query: '',
    showResults: false,
    selectedYear: selectedYear,
    isLoading: false,
    abortController: null,

    init() {
        const boundUpdateResults = this.updateResults.bind(this)

        this.$watch('query', debounce(300, boundUpdateResults))
        this.$watch('selectedYear', (year) => {
            this.updateYear()
            this.scrollToYear(year)
        })

        window.addEventListener(
            'pageshow',
            () => (this.query = this.$refs.input?.value || '')
        )
    },

    clearQuery() {
        this.query = ''
    },

    replaceRef(name) {
        const url = new URL(window.location.pathname, window.location.origin)

        if (this.query) {
            url.searchParams.set('term', this.query)
        } else {
            url.searchParams.set('y', this.selectedYear)
        }

        this.abortController?.abort()

        this.abortController = new AbortController()

        return fetch(url, { signal: this.abortController.signal })
            .then((response) => response.text())
            .then((html) => {
                const parser = new DOMParser()
                const doc = parser.parseFromString(html, 'text/html')
                const results = doc.querySelector(`[x-ref="${name}"]`)

                if (results) {
                    this.$refs[name].innerHTML = results.innerHTML
                }
            })
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    console.error(error)
                }
            })
            .finally(() => {
                this.abortController = null
            })
    },

    updateResults() {
        if (this.query) {
            this.isLoading = true
            this.showResults = true

            this.replaceRef('results').finally(() => {
                this.isLoading = false
            })
        } else {
            this.showResults = false
        }
    },

    updateYear() {
        this.isLoading = true
        this.query = ''

        this.$refs.bands?.scrollIntoView({ behavior: 'smooth', block: 'start' })

        this.replaceRef('track').finally(() => {
            this.isLoading = false
        })
    },

    scrollToYear(year) {
        const navigation = this.$refs.navigation
        const navigationChildren = navigation.querySelectorAll('li')
        const activeNavigationChild = [...navigationChildren].find(
            ({ dataset }) => dataset.year == year
        )
        const margin =
            navigation.offsetWidth / 2 - activeNavigationChild.offsetWidth / 2

        navigation.scrollTo({
            left: activeNavigationChild.offsetLeft - margin,
            behavior: 'smooth',
        })
    },
})
